import { useCallback, useEffect, useState } from "react";
import { BooleanInput, Create, Edit, SimpleForm, TextInput, useDataProvider, useNotify, useRefresh } from "react-admin";
import { FileInputSingleForBanner, FileInputSingleLarge } from "../fileinputs/eventFileUpload";



export function UploadBanner(props) {
    const notify = useNotify();
    const refresh = useRefresh();

    // const banner = { showBanner: false, bannerUrl: 'https://kidscur-dms.s3.ap-south-1.amazonaws.com/banners/heydrabad_POPup+(1).jpg', redirectUrl: "https://www.instagram.com/reel/C2eV89mJNS-/?igsh=cGZnY3Rsbmlvajhm", }


    const [bannerData, setBannerData] = useState({});
    const [banner, setBanner] = useState({});
    const dataProvider = useDataProvider();

    const getBanner = useCallback(async () => {
        dataProvider.getList("appSettings", {
            pagination: { page: 1, perPage: 1 },
            sort: { field: "id", order: "ASC" },
            filter: { name: "banner" }

        }).then(({ data, message }) => {
            console.log("data-", data);
            if (data && data.length > 0) {
                setBannerData(data[0]);
                if (data[0].value && typeof data[0].value === "string") {
                    setBanner(JSON.parse(data[0].value));
                }else{
                    setBanner(data[0].value);
                }
            }
        })
    }, []);

    useEffect(() => {
        getBanner();
    }, []);


    console.log("banner", bannerData, banner);




    return (
        <>
            <div>Banner</div>
            {
                bannerData?.id && <Edit resource="appSettings" id={bannerData?.id}>
                    <SimpleForm
                        values={banner}
                        onSubmit={
                            (formVAlues) => {
                                dataProvider.update("appSettings", {
                                    id: bannerData?.id,
                                    data: {
                                        value: formVAlues

                                    }
                                }).then(({ data, message }) => {
                                    if (data?.id) {
                                        notify("Banner Updated", { type: "success" });
                                        getBanner();
                                        refresh();
                                    } else {
                                        notify("Banner Not Updated", { type: "error" });
                                    }
                                }).catch((error) => {
                                    notify(error.message, { type: "error" });
                                })
                            }
                        }>
                        <BooleanInput source="showBanner" />
                        <TextInput source="bannerUrl" fullWidth />
                        <FileInputSingleForBanner source="bannerUrl" edit />
                        {/* <FileInputSingleLarge source="bannerUrl" edit /> */}

                        <TextInput source="redirectUrl" type="url" fullWidth />
                    </SimpleForm>
                </Edit>
            }

        </>

    )
}


